import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Utils } from 'src/app/core/resources/utils';

@Component({
  selector: 'app-cargo-creation-modal',
  templateUrl: './cargo-creation-modal.component.html',
  styleUrls: ['./cargo-creation-modal.component.scss']
})
export class CargoCreationModalComponent implements OnInit {
  private cargos: Cargo[];
  public cargosWithErrors: { cargo: Cargo, error?: string }[] = [];
  public cargosWithoutErrors: { cargo: Cargo }[] = [];
  public title: string;

  constructor(
    public utils: Utils,
    public dialogRef: MatDialogRef<CargoCreationModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      cargos: Cargo[],
      title: string,
      cargosWithErrors?: { consecutive: string, error: string }[],
      cargosWithoutErrors?: string[]
    },
  ) {
    this.cargos = this.data.cargos;
    this.title = this.data.title;
  }

  ngOnInit() {
    if (this.data.cargosWithErrors)
      this.cargosWithErrors = this.data.cargosWithErrors.map(cargo => ({ cargo: this.cargos.find(c => c.consecutive === Number(cargo.consecutive)), error: cargo.error }));
    else this.cargosWithErrors = this.cargos.filter(cargo => !cargo || !cargo.id).map(cargo => ({ cargo, error: null }));
    if (this.data.cargosWithoutErrors)
      this.cargosWithoutErrors = this.data.cargosWithoutErrors.map(cargo => ({ cargo: this.cargos.find(c => c.consecutive === Number(cargo)) }));
    else this.cargosWithoutErrors = this.cargos.filter(cargo => !!(cargo && cargo.id)).map(cargo => ({ cargo }));
  }

  goToCargo(cargo: Cargo) {
    this.utils.openCargoNewTab(cargo);
  }

  get hasCommonCargoList(): { list: string, state: string } {
    if (this.cargosWithoutErrors.length === 0) return null;
    if (this.cargosWithoutErrors.every(cargo => cargo && cargo.cargo && cargo.cargo.state === CargoStateEnum.REQUEST))
      return { list: 'request', state: 'solicitudes' };
    if (this.cargosWithoutErrors.every(cargo => cargo && cargo.cargo && cargo.cargo.state === CargoStateEnum.START_SERVICE))
      return { list: 'loadingRoutes', state: 'servicios en ruta' };
    if (this.cargosWithoutErrors.every(cargo => cargo && cargo.cargo && [CargoStateEnum.CREATED, CargoStateEnum.ACCEPTED].includes(cargo.cargo.state)))
      return { list: 'scheduledLoads', state: 'servicios programados' };
    return null;
  }

  goToListCargos() {
    const state = this.hasCommonCargoList;
    this.dialogRef.close({ path: `/cargo/list/${state.list}` });
  }
}
